import React from 'react';
import ReactDOM from 'react-dom/client';

function ConfirmModal({ message, onResolve }) {
  return (
    <div style={overlayStyle}>
      <div style={modalStyle} role="dialog" aria-modal="true">
        <div style={{ marginBottom: 16 }}>{message}</div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={() => onResolve(false)} style={btnStyle}>Cancel</button>
          <button onClick={() => onResolve(true)} style={primaryBtnStyle}>Yes</button>
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.45)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const modalStyle = {
  background: '#fff',
  padding: 20,
  borderRadius: 8,
  maxWidth: 480,
  width: '90%',
  boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
};

const btnStyle = {
  padding: '8px 12px',
  borderRadius: 6,
  border: '1px solid #ddd',
  background: '#fff',
  cursor: 'pointer',
};

const primaryBtnStyle = {
  ...btnStyle,
  background: '#0B5FFF',
  color: '#fff',
  border: '1px solid #0B5FFF',
};

export function confirm(message) {
  if (typeof document === 'undefined') return Promise.resolve(false);

  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = ReactDOM.createRoot(container);

    function cleanup(result) {
      try {
        root.unmount();
      } catch (e) {
        // ignore
      }
      if (container.parentNode) container.parentNode.removeChild(container);
      resolve(result);
    }

    root.render(<ConfirmModal message={message} onResolve={cleanup} />);
  });
}

export default confirm;
